import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AppContext from '../../contexts/AppContext';

const RequireAuth = ({ children }) => {
  const { token, loading } = useContext(AppContext);
  const navigate = useNavigate();
  const hasUrlToken = new URLSearchParams(window.location.search).has('token');

  useEffect(() => {
    // 如果 URL 里正好有 token，就让 AppContext 先去处理，RequireAuth 暂不跳
    if (loading || hasUrlToken) return;
    if (!token) {
      navigate('/login');
    }
  }, [token, loading, hasUrlToken, navigate]);

  if (loading || hasUrlToken) {
    return <div>Loading...</div>;
  }
  return <>{children}</>;
};

export default RequireAuth;
